import { POPOVER_PARTS } from './popoverParts';
import type { PopoverStyleConfig } from './types';

const baseStyle: PopoverStyleConfig['baseStyle'] = () => ({
  overlay: {
    zIndex: 'popover',
  },
  popper: {
    fontFamily: 'default',
    fontWeight: 'default',
    fontSize: 'md',
    lineHeight: 'md',
    zIndex: 'popover',
    position: 'relative',
  },
  content: {
    // These custom variables for arrow styling are pulled straight from Chakra source and seem to be required
    '--popover-bg': `var(--chakra-colors-page-surface)`,
    bg: 'var(--popover-bg)',
    '--popper-arrow-bg': 'var(--popover-bg)',
    '--popper-arrow-shadow-color': `var(--chakra-colors-separator-border)`,
    '--popper-arrow-size': '0.75rem',
    borderRadius: 'md',
    border: '1px solid',
    borderColor: 'separator.border',
    boxShadow: 'popover',
    fontSize: 'md',
    lineHeight: 'md',
    minWidth: 'min-content',
    zIndex: 'inherit',
    _focusVisible: {
      outline: 0,
      boxShadow: 'focus',
    },
  },
  header: {
    alignItems: 'center',
    borderBottom: '1px solid',
    borderColor: 'separator.divider',
    display: 'flex',
    flexDirection: 'row',
    fontWeight: 'heavy',
    color: 'primary',
    justifyContent: 'space-between',
    minWidth: 'max-content',
    px: 1.5,
    textTransform: 'capitalize',
  },
  body: {
    px: 1.5,
    py: 1,
  },
  footer: {
    borderTop: '1px solid',
    borderColor: 'separator.divider',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    h: 5,
    justifyContent: 'flex-end',
    minWidth: 'max-content',
    px: 1.5,
  },
  arrow: {},
});

const SIZES = {
  sm: {
    content: {
      w: 30,
    },
    header: {
      h: 4,
      fontSize: 'md',
      lineHeight: 'md',
    },
    footer: {
      h: 5,
      px: '0.625rem',
    },
  },
  md: {
    content: {
      w: 40,
    },
    header: {
      h: 5,
      fontSize: 'lg',
      lineHeight: 'lg',
    },
    footer: {
      h: 6,
      px: 1.5,
    },
  },
  lg: {},
};

export const POPOVER_STYLE_CONFIG: PopoverStyleConfig = {
  parts: POPOVER_PARTS,
  baseStyle,
  sizes: SIZES,
};
